'use strict'
Object.defineProperty(exports, '__esModule', { value: true })
function isFunction(value) {
  var type = typeof value
  return value != null && type == 'function'
}
exports.default = isFunction
